import React from 'react'
import { Modal } from '@mui/material'
import tw from 'twin.macro'
import { ModalHeader } from 'src/components/shared/ModalHeader'
import { InviteTeamMemberForm } from './invite-team-member-form/InviteTeamMemberForm'
import { TeamTableTab } from 'src/constants/team/enums'

interface Props {
  isInviteTeamMemberOpen: boolean
  closeInviteTeamMember(): void
  setSelectedTab: (tab: TeamTableTab) => void
  onRefreshTeamMemberInvites: () => void
}

export const InviteTeamMemberModal = ({
  isInviteTeamMemberOpen,
  closeInviteTeamMember,
  setSelectedTab,
  onRefreshTeamMemberInvites,
}: Props) => {
  const container = document.getElementById('root')

  return (
    <Modal
      container={container}
      open={isInviteTeamMemberOpen}
      onClose={closeInviteTeamMember}
      aria-labelledby="invite-team-member-modal-title"
      aria-describedby="invite-team-member-modal-description"
      css={tw`flex flex-row w-full h-full`}
    >
      <>
        <div css={tw`w-[400px] h-full bg-white flex flex-col overflow-hidden`}>
          <ModalHeader title="Invite user" onClose={closeInviteTeamMember} />
          <div css={tw`flex-1 min-h-0 flex flex-col`}>
            <InviteTeamMemberForm
              closeInviteTeamMember={closeInviteTeamMember}
              setSelectedTab={setSelectedTab}
              onRefreshTeamMemberInvites={onRefreshTeamMemberInvites}
            />
          </div>
        </div>
        <div id="team-details" css={tw`flex m-6 w-[440px] pointer-events-none`} />
      </>
    </Modal>
  )
}
